import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getPatientManagementTableEnrichedDataWithKeycloak } from '../../services';
import { ConnectedUsers } from '../../pages/DoctorManagement/types';

export interface Patient {
  firstName: string;
  lastName: string;
  verifiedOn: string;
  id: string;
  fullName: string;
  gender: string;
  email: string;
  status: string;
  image: string;
  connectedUsers: ConnectedUsers[];
}

export interface PatientsListResponse {
  data: Patient[];
  hasMore: boolean;
  totalCount: number;
  lastUpdatedAt?: string;
}

export interface PatientsListParams {
  limit?: number;
  created_at?: string;
  ageStart?: string;
  ageEnd?: string;
  gender?: string;
}

export const usePatientsListQuery = (params: PatientsListParams) => {
  return useQuery<PatientsListResponse>({
    queryKey: ['patients-list', params],
    queryFn: async () => {
      const result = await getPatientManagementTableEnrichedDataWithKeycloak(
        params.limit ?? 10,
        params.created_at,
        params.ageStart,
        params.ageEnd,
        params.gender
      );

      return {
        data: result.data,
        hasMore: result.hasMore,
        totalCount: result.totalCount,
        lastUpdatedAt: result.lastUpdatedAt
      };
    },
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled: true
  });
};
